/**
 * Values a list cell has saved, shown until the reloaded row arrives - kept by column and ticket rather than in the
 * cell: rows are keyed by position, so when a row above leaves the view the cell showing a ticket changes while it
 * waits, and a cell's own state put the old value back - the second of two quick Status changes showed Active again
 * as it faded.
 */

/** A row that comes back unchanged (an automation put the value back) never moves the cell's value; let go anyway. */
export const PENDING_LIMIT_MS = 5000;

const saves = new Map<string, { value: number | null; until: number }>();

export const pendingKey = (column: string, ticketId: number) => `${column}:${ticketId}`;

/** A save has started: its value shows for as long as the save takes. */
export const holdPending = (key: string, value: number | null) => { saves.set(key, { value, until: Infinity }); };

/** The save has answered: its value shows a while longer, until the reload brings it or the limit passes. */
export const settlePending = (key: string, now = Date.now()) => {
  const save = saves.get(key);
  if (save) save.until = now + PENDING_LIMIT_MS;
};

export const dropPending = (key: string) => { saves.delete(key); };

/** The value waiting for this column and ticket, or undefined when there is none. */
export const pendingValue = (key: string, now = Date.now()): { value: number | null } | undefined => {
  const save = saves.get(key);
  if (!save) return undefined;
  if (save.until <= now) {
    saves.delete(key);
    return undefined;
  }
  return { value: save.value };
};
